import React from 'react';

import {sendMobileAnalyticsEvent} from '@optimaxdev/analytics/mobile/lib/sendAnalyticsEvent/index';
import {Link} from 'react-router-dom';

import {CART_BUTTON} from 'constants/analytics/events/cart';
import {SHOW_WIZARD} from 'constants/product';

import s from './productName.scss';

type PropsType = {
    isCartPage: boolean;
    id: number;
    sku: string;
    windowName: string;
    isVista?: boolean;
};
/**
 * Name component for product card on cart and checkout pages
 */
export const ProductName = ({id, isCartPage, isVista = false, sku, windowName}: PropsType) => {
    const sendProductDetailsClickEvent = () => {
        sendMobileAnalyticsEvent(CART_BUTTON, {
            action: 'Product Details',
            label: 'Product Name',
        });
    };

    return isCartPage ? (
        <Link
            to={{
                pathname: `/checkout/cart/configure/id/${id}/${sku}.html`,
                search: `?${SHOW_WIZARD}=false`,
            }}
            className={isVista ? s.vistaName : s.name}
            onClick={sendProductDetailsClickEvent}
            role="button"
            title="Show item page"
        >
            {windowName}
        </Link>
    ) : (
        <p className={isVista ? s.vistaName : s.name}>{windowName}</p>
    );
};
